import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import videoContentFetcherHoc from "@hocs/videoContentFetcherHoc";
import {VideoContent} from "@models/video-content";


const Option = Select.Option;


export interface VideoContentMultiSelectionReturnValue {
  new_videos: string[];
  deleted_videos: string[];
  selectedItems: VideoContent[]
}

export const videoContentMultiSelectionDefaultReturnValue: VideoContentMultiSelectionReturnValue = {
  new_videos: [],
  deleted_videos: [],
  selectedItems: []
};

type VideoContentSelectionProps = {
  mode: SelectionMode,
  onChange: (value: VideoContentMultiSelectionReturnValue) => void
  selectedVideoContents: VideoContent[],
  data: VideoContent[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  fetchData: (params: object | null) => void,
  filter?: object,
  isFetched: boolean,
  initialValue: VideoContent[] | VideoContent | null
  disabled:boolean
}


/**
 * This class handle selection of categories
 * Use Select fro ant-design because it has on scroll option
 * In terms of lazy loading of data, selected items should bre rendered separated
 * On Change callback return an object from new and deleted categories
 * @param props
 * @constructor
 */
const VideoContentsSelection: React.FC<VideoContentSelectionProps> = props => {
  const {handleSearch, onScroll, disabled=false, data = [], initialValue, onChange, fetchData, isFetched, mode = SelectionMode.DEFAULT} = props;
  const defaultValue = mode == SelectionMode.MULTIPLE ? [] : null;
  
  const retrieveValueFromProps = () => {
    if (mode == SelectionMode.MULTIPLE) {
      const returnValue = props.initialValue || [];
      return returnValue.map(item => item.id)
    }
    else {
      return props.initialValue ? props.initialValue.id : null
    }
  };
  
  const [value, setValue] = useState(initialValue ? retrieveValueFromProps() : defaultValue);
  
  useEffect(() => {
    const value = retrieveValueFromProps();
    setValue(value);
  }, [props.initialValue]);
  
  
  /**
   * To handle show selected categories before fetch data
   */
  const getData = () => {
    if (mode == SelectionMode.MULTIPLE) {
      let returnData = data;
      const selectedValues = props.initialValue || [];
      selectedValues.forEach(videoContent => {
        if (returnData.findIndex(opt => opt.id === videoContent.id) === -1) {
          returnData.push(videoContent)
        }
      });
      
      return returnData;
    }
    else {
      return initialValue && !data.find(opt => opt.id == initialValue.id) ? [...data, initialValue] : data;
    }
  };
  
  const onChangeValue = (newValue, option) => {
    setValue(newValue);
    if (mode == SelectionMode.MULTIPLE) {
      const selectedValues = props.initialValue || [];
      const oldValue = selectedValues.map(cat => cat.id);
      const deleted_videos = oldValue.filter(item => newValue.findIndex(id => id === item) === -1);
      const new_videos = newValue.filter(item => oldValue.findIndex(id => id === item) === -1);
      props.onChange({
        deleted_videos,
        new_videos,
        selectedItems: option.map(opt => opt.props.videoContent)
      });
    }
    else {
      onChange(option.props.videoContent)
    }
  };
  
  const onFocus = () => {
    if (isFetched == false) {
      fetchData({});
    }
  };
  
  return (
    <Select
      showSearch
      mode={mode}
      disabled={disabled}
      value={value}
      defaultActiveFirstOption={false}
      showArrow={true}
      filterOption={false}
      onChange={onChangeValue}
      onFocus={onFocus}
      onSearch={handleSearch}
      onPopupScroll={onScroll}
      notFoundContent={null}
    >
      {getData().map(videoContent =>
        <Option key={videoContent.id} videoContent={videoContent}>{videoContent.title}</Option>
      )}
    </Select>
  );
};

export default videoContentFetcherHoc(VideoContentsSelection);


